module.exports = "/_next/static/images/gridOptimization2x-d50ece0f516b4ae0b1ca1d39ecaab1ed.png";